import { useMemo } from 'react';
import { Control } from 'react-hook-form';

import AutocompleteFormField from './formFields/AutocompleteFormField';
import ImageFormField from './formFields/ImageFormField';
import TextFieldFormField from './formFields/TextFieldFormField';
import {
	AutocompleteFieldType,
	DefaultFormType,
	FormFieldEnum,
	ImageFieldType,
	SpecificFieldsType,
	TextFieldType,
} from '../types/form';

type ExternalApplicationFormFieldProps = {
	control: Control<DefaultFormType>;
	specificFields: SpecificFieldsType[];
};

const ExternalApplicationFormField = ({ control, specificFields }: ExternalApplicationFormFieldProps) => {
	const renderedSpecificFields = useMemo(
		() => (
			<>
				{specificFields.map((specificField) => {
					const { key, type: specificFieldType } = specificField || {};

					if (specificFieldType === FormFieldEnum.TEXTFIELD) {
						return <TextFieldFormField key={key} control={control} specificField={specificField as TextFieldType} />;
					}

					if (specificFieldType === FormFieldEnum.AUTOCOMPLETE) {
						return (
							<AutocompleteFormField
								key={key}
								control={control}
								specificField={specificField as AutocompleteFieldType<unknown>}
							/>
						);
					}

					if (specificFieldType === FormFieldEnum.IMAGE) {
						return <ImageFormField key={key} control={control} specificField={specificField as ImageFieldType} />;
					}

					return undefined;
				})}
			</>
		),
		[control, specificFields],
	);

	return renderedSpecificFields;
};

export default ExternalApplicationFormField;
